<template>
  <div>
    <vs-table ref="table" max-items="10" search :data="evaluations">
      <template slot="thead">
        <vs-th>Evaluation</vs-th>
        <vs-th>Période</vs-th>
        <vs-th>Clés</vs-th>
        <vs-th>Action</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>{{
              tr.period.start_date + " au " + tr.period.end_date
            }}</vs-td>
            <vs-td>{{ tr.period.keys.length }}</vs-td>
            <vs-td>
              <div class="flex">
                <vx-tooltip
                  :text="
                    isAdmin ? 'Saisir les performances' : 'Mes performances'
                  "
                >
                  <feather-icon
                    @click="goTo(tr)"
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: "principal",
  data: () => ({
    evaluations: [],
  }),
  computed: {
    isAdmin() {
      return window.getApp.isAdmin();
    },
  },
  methods: {
    loadEvaluation() {
      let checkAdmin = window.getApp.isAdmin();
      let url = checkAdmin ? "/performances" : "/performances/agent";
      this.$vs.loading();
      this.$http
        .get(url)
        .then((response) => {
          this.evaluations = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    goTo(evaluation) {
      let checkAdmin = window.getApp.isAdmin();
      let checkTeamChef = window.getApp.isTeamChef();
      if (checkAdmin || checkTeamChef) {
        this.$router.push({
          name: "enter_perf",
          params: { id: evaluation.id },
        });
      }else{
        this.$router.push({
          name: "agent_enter_perf",
          params: { },
        });
      }
    },
  },
  mounted() {
    this.loadEvaluation();
  },
};
</script>

<style scoped>
</style>
